import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { useMaterialUIController } from "context";
import { setIsVipUser } from "context";
import { actionCodeMenus } from "globals/configuration/pbxServiceMenu";
import formControl from "globals/form-control";

const Attributes = {
  formSize: "md",
  columns: 1,
  enableAddButton: true,
  enableAdvanceSearch: true,
  modes: actionCodeMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  settingsMode: false,
};

const operationURLS = {
  list: "extensions/list/trunkAccessCode",
  create: "extensions/create/trunkAccessCode",
  update: "extensions/update/trunkAccessCode",
  delete: "extensions/delete/extension",
};

const getColumns = (onEdit, onDelete) => {
  const [controller, dispatch] = useMaterialUIController();
  const { isVipUser } = controller;

  const onChangeGlobal = (event, formik) => {
    if (event.target.value === "tac") {
      setIsVipUser(dispatch, true);
    } else {
      setIsVipUser(dispatch, false);
    }
  };
  return [
    {
      Header: "Code",
      accessor: "extension",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },

    {
      Header: "Global",
      accessor: "extensionType",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      onChange: onChangeGlobal,
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
      controlType: "select",
      options: {
        keyField: "shortcode",
        keyDescription: "description",
        values: [
          { shortcode: "tac", description: "Normal" },
          { shortcode: "gtac", description: "Authorize" },
          { shortcode: "ptac", description: "Patch Call" },
          { shortcode: "ctac", description: "Call Back" },
        ],
        url: "",
      },
    },
    {
      Header: "Gateway",
      accessor: "data",
      displayInList: true,
      allowFilter: false,
      allowInForm: isVipUser,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "gwCode",
        keyDescription: "gwCode",
        values: [],
        url: "gateway/listAll/gwCode",
      },
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onCustomUpdate={onEdit}
          onDelete={onDelete}
          customUpdateCondition={(data) => data.extensionType === "tac"}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
